import React from 'react';
import { Route } from 'react-router-dom';

import ConnectedSwitch from './ConnectedSwitch';
import Login from '../client/containers/login';
import Dashboard from '../client/containers/dashboard';
import LoginCallback from '../client/containers/login_callback';
import TasksManagerDetail from '../client/containers/tasks_manager_detail';

function Routes() {
  return (
    <main role="application">
      <ConnectedSwitch>
        {/* Login */}
        <Route path="/" exact component={Login} />
        <Route path="/lang/:lang" component={Login}/>
        <Route path="/dashboard" component={Dashboard}/>
        <Route path="/fullscreen" component={Dashboard}/>
        <Route path="/login/callback" component={LoginCallback}/>
        <Route path="/login/redirect" component={Login} />
        <Route path="/tasks_manager_detail" component={TasksManagerDetail}/>

        {/* Error 404 */}
        <Route component={Login} />
      </ConnectedSwitch>
    </main>
  );
}

export default Routes;



// WEBPACK FOOTER //
// ./source/router/Routes.jsx